<div class="modal fade" id="searchApplicationsModal" tabindex="-1" role="dialog" aria-labelledby="selectOfferModalTitle"
    data-keyboard="false" data-backdrop="static" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="onCloseSearchModal()">
                    <img src="/assets/images/icons/close_b.svg" alt="close" />
                    CLOSE WINDOW
                </button>
            </div>
            <div class="modal-body">
                <h5 class="modal-title w-100 text-left font-mont-bold" id="exampleModalLongTitle">
                    <em class="fas fa-search"></em>
                    Search by single or multiple options...
                </h5>
                <form [formGroup]="searchForm.form" (ngSubmit)="onSearchClick();">
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="name">Search</label>
                            <input type="text" formControlName="name" class="form-control" id="name" name="name">
                        </div>
                        <div class="form-group float-left col-md-6 text-right">
                            <button type="submit"
                                class="btn btn-primary btn-lg col-md-12 col-xs-12 round-button">Search</button>
                            <button type="button" class="btn btn-primary btn-lg col-md-12 col-xs-12 round-button"
                                (click)="onClearClick();">Clear</button>
                        </div>
                    </div>
                    <div class="form-row" [ngClass]="{'table-container': searchApplications.length > 0}">
                        <div class="form-group col-md-12">
                            <table class="table search-table" *ngIf="searchApplications.length > 0">
                                <thead class="hide-mobile">
                                    <tr>
                                        <th scope="col" class="text-left">
                                            <div class="font-mont-semi-bold">ID</div>
                                        </th>
                                        <th scope="col" class="text-center">
                                            <div class="font-mont-semi-bold">Vendor</div>
                                            <div class="font-mont-semi-bold">Name</div>
                                        </th>
                                        <th scope="col" class="text-center">
                                            <div class="font-mont-semi-bold">Owner</div>
                                            <div class="font-mont-semi-bold">Name</div>
                                        </th>
                                        <th scope="col" class="text-center">
                                            <div class="font-mont-semi-bold">Business</div>
                                            <div class="font-mont-semi-bold">Name</div>
                                        </th>
                                        <th scope="col" class="text-center">
                                            <div class="font-mont-semi-bold">Email</div>
                                        </th>
                                        <th scope="col" class="text-center">
                                            <div class="font-mont-semi-bold">Phone #</div>
                                        </th>
                                        <th scope="col" class="text-right">
                                            <div class="font-mont-semi-bold">Cell #</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let app of searchApplications; let i = index">
                                        <tr (click)="onSearchCellClick(app.id);" data-dismiss="modal"
                                            class="hide-mobile">
                                            <td scope="row">{{app.id}}</td>
                                            <td class="text-center">{{app.vendorName}}</td>
                                            <td class="text-center">{{app.ownersName}} </td>
                                            <td class="text-center">{{app.legalName}} </td>
                                            <td class="text-center">{{app.ownersEmail}}</td>
                                            <td class="text-center">{{app.ownersPhone | mask: '(000) 000-0000'}}</td>
                                            <td class="text-right">{{app.ownersCell | mask: '(000) 000-0000'}}</td>
                                        </tr>
                                        <tr (click)="onSearchCellClick(app.id);" data-dismiss="modal"
                                            class="only-mobile-row">
                                            <td>
                                                <div class="font-mont-semi-bold">ID:</div> {{app.id}}
                                            </td>
                                        </tr>
                                        <tr (click)="onSearchCellClick(app.id);" data-dismiss="modal"
                                            class="only-mobile-row">
                                            <td>
                                                <div class="font-mont-semi-bold">Owner Name:</div> {{app.ownersName}}
                                            </td>
                                        </tr>
                                        <tr (click)="onSearchCellClick(app.id);" data-dismiss="modal"
                                            class="only-mobile-row">
                                            <td>
                                                <div class="font-mont-semi-bold">Business Name:</div> {{app.legalName}}
                                            </td>
                                        </tr>
                                        <tr (click)="onSearchCellClick(app.id);" data-dismiss="modal"
                                            class="only-mobile-row">
                                            <td>
                                                <div class="font-mont-semi-bold">Email:</div> {{app.ownersEmail}}
                                            </td>
                                        </tr>
                                        <tr (click)="onSearchCellClick(app.id);" data-dismiss="modal"
                                            class="only-mobile-row">
                                            <td>
                                                <div class="font-mont-semi-bold">Phone #:</div> {{app.ownersPhone |
                                                mask:
                                                '(000) 000-0000'}}
                                            </td>
                                        </tr>
                                        <tr (click)="onSearchCellClick(app.id);" data-dismiss="modal"
                                            class="only-mobile-row">
                                            <td>
                                                <div class="font-mont-semi-bold">Cell #:</div> {{app.ownersCell | mask:
                                                '(000) 000-0000'}}
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                            <div class="not-records-found"
                                *ngIf="searchApplications.length < 1 && applicationsSearched">
                                <hr /> No records found
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<div class="table-responsive mh-260" style="min-height: 260px">
    <nav aria-label="Page navigation example">
        <button type="button" class="btn btn-primary search-button" (click)="openSearchModal();">
            Search <img src="/assets/images/icons/search_down.svg" />
        </button>
        <div class="pagination-amount" (click)="toggleResultsTopOpen()">
            RESULTS PER PAGE: {{sliceSize}}
            <img src="/assets/images/icons/down.svg" />
            <div class="results-top" [ngClass]="{'open': resultsTopOpen}">
                <div class="backdrop"></div>
                <div class="results-top-options">
                    <div class="font-mont-semi-bold">
                        <div (click)="loadNApplications(10);" role="button">10</div>
                        <div (click)="loadNApplications(25);" role="button">25</div>
                        <div (click)="loadNApplications(50);" role="button">50</div>
                    </div>
                </div>
            </div>
        </div>
        <ul class="pagination justify-content-end">
            <li class="page-item" [ngClass]="{'disabled': sliceNumber == 0}" (click)="onFirstClick();">
                <a class="page-link prev" tabindex="-1"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-skip-backward-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M.5 3.5A.5.5 0 0 0 0 4v8a.5.5 0 0 0 1 0V4a.5.5 0 0 0-.5-.5z"/>
                    <path d="M.904 8.697l6.363 3.692c.54.313 1.233-.066 1.233-.697V4.308c0-.63-.692-1.01-1.233-.696L.904 7.304a.802.802 0 0 0 0 1.393z"/>
                    <path d="M8.404 8.697l6.363 3.692c.54.313 1.233-.066 1.233-.697V4.308c0-.63-.693-1.01-1.233-.696L8.404 7.304a.802.802 0 0 0 0 1.393z"/>
                  </svg></a>
            </li>
            <li class="page-item" [ngClass]="{'disabled': sliceNumber == 0}" (click)="onBackClick();">
                <a class="page-link prev" tabindex="-1"><img src="/assets/images/icons/prev.svg" alt="prev" /></a>
            </li>
            <li class="page-item" *ngFor="let slice of slices" [ngClass]="{'active': sliceNumber + 1 == slice}"
                (click)="onSliceClick(slice - 1);">
                <a class="page-link" *ngIf="slice - 1 > sliceNumber - 5 && sliceNumber + 5 > slice - 1">{{slice}}</a>
            </li>
            <li class="page-item" [ngClass]="{'disabled': sliceNumber == totalPages - 1}" (click)="onNextClick();">
                <a class="page-link next"><img src="/assets/images/icons/next.svg" alt="next" /></a>
            </li>
            <li class="page-item" [ngClass]="{'disabled': sliceNumber == 0}" (click)="onLastClick();">
                <a class="page-link prev" tabindex="-1"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-skip-forward-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M15.5 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5z"/>
                    <path d="M7.596 8.697l-6.363 3.692C.693 12.702 0 12.322 0 11.692V4.308c0-.63.693-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
                    <path d="M15.096 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.693-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
                  </svg> </a>
            </li>
        </ul>
    </nav>
    <table class="table app-list-table">
        <thead>
            <tr>
                <th scope="col" class="text-left">
                    <div class="font-mont-semi-bold">Business</div>
                    <div class="font-mont-semi-bold">Name</div>
                </th>
                <th *ngIf="showVend" scope="col" class="text-center hide-mobile">
                    <div class="font-mont-semi-bold">Vendor</div>
                    <div class="font-mont-semi-bold">Name</div>
                </th>
                <th scope="col" class="text-center hide-mobile">
                    <div class="font-mont-semi-bold">Application</div>
                    <div class="font-mont-semi-bold">ID</div>
                </th>
                <th scope="col" class="text-center hide-mobile">
                    <div class="font-mont-semi-bold">Owner</div>
                    <div class="font-mont-semi-bold">Name</div>
                </th>
                <th scope="col" class="text-center hide-mobile">
                    <div class="font-mont-semi-bold">Sales</div>
                    <div class="font-mont-semi-bold">Associate</div>
                </th>
                <th scope="col" class="text-center td-w-130 hide-mobile">
                    <div class="font-mont-semi-bold">Approval</div>
                    <div class="font-mont-semi-bold">Amount</div>
                </th>
                <th scope="col" class="text-right position-relative cursor-pointer td-w-150"
                    (click)="toggleStatusFilter()">
                    <div class="font-mont-semi-bold margin-r-20">
                        Current
                    </div>
                    <div class="font-mont-semi-bold margin-r-20">Status</div>
                    <em class="fas fa-filter filter-icon"></em>
                    <div class="apps-menu r-0" [ngClass]="{'open': statusFilterOpen, 'show-preapp': showPreapprovalFilter}">
                        <div class="backdrop"></div>
                        <div class="apps-menu-container">
                            <div (click)="onStatusCheckClick('APPROVED');">
                                <em *ngIf="selectedStatus == 'APPROVED'" class="far fa-dot-circle"></em>
                                <em *ngIf="selectedStatus != 'APPROVED'" class="far fa-circle"></em>
                                <span class="font-mont-semi-bold"> Active </span>
                                <div class="clear"></div>
                            </div>
                            <div (click)="onStatusCheckClick('DECLINED/ABANDONED');">
                                <em *ngIf="selectedStatus == 'DECLINED/ABANDONED'" class="far fa-dot-circle"></em>
                                <em *ngIf="selectedStatus != 'DECLINED/ABANDONED'" class="far fa-circle"></em>
                                <span class="font-mont-semi-bold"> Declines </span>
                                <div class="clear"></div>
                            </div>
                            <div (click)="onStatusCheckClick('FUNDED');">
                                <em *ngIf="selectedStatus == 'FUNDED'" class="far fa-dot-circle"></em>
                                <em *ngIf="selectedStatus != 'FUNDED'" class="far fa-circle"></em>
                                <span class="font-mont-semi-bold"> Funded </span>
                                <div class="clear"></div>
                            </div>
                            <div (click)="onStatusCheckClick('PRE_APPROVAL');" *ngIf="showPreapprovalFilter">
                                <em *ngIf="selectedStatus == 'PRE_APPROVAL'" class="far fa-dot-circle"></em>
                                <em *ngIf="selectedStatus != 'PRE_APPROVAL'" class="far fa-circle"></em>
                                <span class="font-mont-semi-bold"> Bank Verification </span>
                                <div class="clear"></div>
                            </div>
                        </div>
                    </div>
                </th>
                <th scope="col" class="text-right position-relative cursor-pointer td-w-160"
                    (click)="toggleStepFilter()">
                    <div class="font-mont-semi-bold margin-r-20">Your</div>
                    <div class="font-mont-semi-bold margin-r-20">Next Step</div>
                    <em class="fas fa-filter filter-icon" style="right: 10px;"></em>
                    <div class="apps-menu w-270 r-0" [ngClass]="{'open': stepFilter}">
                        <div class="backdrop"></div>
                        <div class="apps-menu-container w-270">
                            <div *ngFor="let step of steps; index as i" (click)="selectStep(i)">
                                <em *ngIf="step == selectedStep || (step.code == 'Default' && selectedStep.length < 1)"
                                    class="far fa-dot-circle"></em>
                                <em *ngIf="step != selectedStep && !(step.code == 'Default' && selectedStep.length < 1)"
                                    class="far fa-circle"></em>
                                <span class="font-mont-semi-bold">{{step.name}} </span>
                                <div class="clear"></div>
                            </div>
                        </div>
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let app of applications; let i = index">
                <tr (click)="toggleSelectedRow(i, app.id);" class="row-data" [ngClass]="{'selected': selectedRow == i}">
                    <td scope="row"> {{app.legalName}} </td>
                    <td *ngIf="showVend" scope="text-center" class="text-center hide-mobile"> {{app.vendorName}} </td>
                    <td class="text-center hide-mobile"> {{app.id}}  </td>
                    <td class="text-center hide-mobile"> {{getOwnersNames(app)}} </td>
                    <td class="text-center hide-mobile"> {{app.salesPersonAssociate}} </td>
                    <td class="text-center td-w-130 hide-mobile"> {{app.approvalAmount | currency:'$ ':'code':'.0-0'}}
                    </td>
                    <td class="text-right td-w-150">
                        <span>{{app.currentStage}}</span>
                        <img *ngIf="getShowCurrentStatusRedIcon(app);" class="customer-action-required"
                            src="/assets/images/icons/red_exclamation.svg" alt="red exc" />
                    </td>
                    <td class="text-right td-w-160">
                        <span [ngClass]="{'disabled': app.nextStepDisabled}">{{app.nextStep}}</span>
                        <img src="/assets/images/icons/{{app.nextStepIcon ? app.nextStepIcon : 'close_a'}}.svg"
                            alt="close" />
                    </td>
                </tr>
                <tr class="no-highlight summary td-w-160" [ngClass]="{'selected': selectedRow == i}">
                    <td [attr.colspan]="summaryColAmount">
                        <div>
                            <app-summary [application]="app.appSummary" [status]="statuses" [industries]="industries"
                                [appId]="app.id" [nextStep]="app.nextStep" [currentStep]="app.currentStage"
                                [nextStepDisabled]="app.nextStepDisabled" [risk]="app.riskInformation"
                                [statesOfIncorporation]="statesOfIncorporation" (reloadSlice)="onReloadSlice();"
                                (toggleSelectedRow)="toggleSelectedRow(i, app.id);" [app]="app">
                            </app-summary>
                        </div>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
    <nav aria-label="Page navigation example">
        <div class="pagination-amount" (click)="toggleResultsBottomOpen()">
            RESULTS PER PAGE: {{sliceSize}}
            <img src="/assets/images/icons/down.svg" alt="down" />
            <div class="results-bottom" [ngClass]="{'open': resultsBottomOpen}">
                <div class="backdrop"></div>
                <div class="results-bottom-options">
                    <div class="font-mont-semi-bold">
                        <div (click)="loadNApplications(10);" role="button">10</div>
                        <div (click)="loadNApplications(25);" role="button">25</div>
                        <div (click)="loadNApplications(50);" role="button">50</div>
                    </div>
                </div>
            </div>
        </div>
        <ul class="pagination justify-content-end">
            <li class="page-item" [ngClass]="{'disabled': sliceNumber == 0}" (click)="onFirstClick();">
                <a class="page-link prev" tabindex="-1"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-skip-backward-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M.5 3.5A.5.5 0 0 0 0 4v8a.5.5 0 0 0 1 0V4a.5.5 0 0 0-.5-.5z"/>
                    <path d="M.904 8.697l6.363 3.692c.54.313 1.233-.066 1.233-.697V4.308c0-.63-.692-1.01-1.233-.696L.904 7.304a.802.802 0 0 0 0 1.393z"/>
                    <path d="M8.404 8.697l6.363 3.692c.54.313 1.233-.066 1.233-.697V4.308c0-.63-.693-1.01-1.233-.696L8.404 7.304a.802.802 0 0 0 0 1.393z"/>
                  </svg></a>
            </li>
            <li class="page-item" [ngClass]="{'disabled': sliceNumber == 0}" (click)="onBackClick();">
                <a class="page-link prev" tabindex="-1"><img src="/assets/images/icons/prev.svg" alt="prev" /></a>
            </li>
            <li class="page-item" *ngFor="let slice of slices" [ngClass]="{'active': sliceNumber + 1 == slice}"
                (click)="onSliceClick(slice - 1);">
                <a class="page-link" *ngIf="slice - 1 > sliceNumber - 5 && sliceNumber + 5 > slice - 1">{{slice}}</a>
            </li>
            <li class="page-item" [ngClass]="{'disabled': sliceNumber == totalPages - 1}" (click)="onNextClick();">
                <a class="page-link next"><img src="/assets/images/icons/next.svg" alt="next" /></a>
            </li>
            <li class="page-item" [ngClass]="{'disabled': sliceNumber == 0}" (click)="onLastClick();">
                <a class="page-link prev" tabindex="-1"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-skip-forward-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M15.5 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5z"/>
                    <path d="M7.596 8.697l-6.363 3.692C.693 12.702 0 12.322 0 11.692V4.308c0-.63.693-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
                    <path d="M15.096 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.693-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
                  </svg> </a>
            </li>
        </ul>
    </nav>
</div>
<div class="modal fade" id="uploadNachaModal" tabindex="-1" role="dialog" aria-labelledby="uploadNachaModal"
    data-keyboard="false" data-backdrop="static" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title w-100 text-center position-absolute" id="exampleModalLongTitle">
                    Please Upload The Ach Documents
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <app-documents-table [documents]="documents"></app-documents-table>
                <app-upload-document (onFileAdded)="onFileAdded($event);"></app-upload-document>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">BACK</button>
                <button type="button" class="btn btn-primary" (click)="onUploadNachaFile();"
                    [disabled]="documents.length < 1" data-dismiss="modal">UPLOAD DOCUMENTS</button>
            </div>
        </div>
    </div>
</div>
<app-error-dialog [modalId]="'ActionMessage'" [title]="messageTitle" [messageA]="messageMessageA"
    [messageB]="messageMessageB" [messageC]="messageMessageC" [messageBClass]="messageMessageBClass"
    [dialogClass]="dialogClass"></app-error-dialog>